import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.file-upload-zone .p-fileupload {
  border: none;
}

.file-upload-zone .p-fileupload-content {
  padding: 0;
  border: none;
}

.file-upload-zone-drop .p-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  width: 100%;
  min-height: 8.5rem;
  padding: 1rem;
  background: ${dt('fileUploadZone.drop.background')};
  border: 1px dashed ${dt('fileUploadZone.drop.borderColor')};
  border-radius: 0;
  color: ${dt('fileUploadZone.drop.textColor')};
}

.file-upload-zone-drop .p-button:enabled:hover {
  border-color: ${dt('primary.color')};
  background: ${dt('surface.100')};
  color: ${dt('fileUploadZone.drop.textColor')};
}

.file-upload-zone-icon {
  font-size: 0.75rem;
  color: ${dt('fileUploadZone.drop.iconColor')};
}

.file-upload-zone-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  margin-top: 0.125rem;
  border-radius: 2px;
  background: ${dt('fileUploadZone.drop.iconWrapBackground')};
}

.file-upload-zone-title {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5rem;
  color: ${dt('fileUploadZone.drop.titleColor')};
}

.file-upload-zone-cta-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
}

.file-upload-zone-cta-muted,
.file-upload-zone-cta-separator {
  color: ${dt('fileUploadZone.drop.formatsColor')};
  font-weight: 400;
}

.file-upload-zone-cta-action {
  color: ${dt('fileUploadZone.drop.actionColor')};
  font-weight: 500;
}

.file-upload-zone-help {
  text-align: center;
  font-size: 0.75rem;
  color: ${dt('fileUploadZone.drop.formatsColor')};
  line-height: 1.125rem;
}

.file-upload-zone-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.file-upload-zone-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 0.75rem;
  background: ${dt('fileUploadZone.list.itemBackground')};
  border-radius: 0;
}

.file-upload-zone-item-existing {
  gap: 1rem;
}

.file-upload-zone-item-readonly {
  padding: 0;
}

.file-upload-zone-item-actions {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
}

.file-upload-zone-item-meta {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.file-upload-zone-item-name {
  flex: 1;
  font-size: 0.875rem;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-upload-zone-item-size {
  font-size: 0.75rem;
  color: ${dt('fileUploadZone.drop.formatsColor')};
}

.file-upload-zone-item-tag {
  margin-left: 0.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 700;
  background: ${dt('surface.100')};
  color: ${dt('text.muted.color')};
}

.file-upload-zone-item-tag.is-error {
  background: ${dt('red.100')};
  color: ${dt('red.700')};
}

.file-upload-zone-error {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.625rem;
  background: ${dt('fileUploadZone.error.background')};
  border: 1px solid ${dt('fileUploadZone.error.borderColor')};
  color: ${dt('fileUploadZone.error.textColor')};
  font-size: 1rem;
  font-weight: 500;
  border-radius: 0.375rem;
  box-shadow: ${dt('fileUploadZone.error.shadow')};
}

.file-upload-zone-error-icon {
  color: ${dt('fileUploadZone.error.textColor')};
}

.file-upload-zone-error-text {
  flex: 1;
}

.file-upload-zone .p-fileupload-header {
  display: none;
}

`;
